import { Injectable } from '@angular/core';
import {
    DeleteImages,
    ImagesFilter,
    MODULES_OPTIONS,
    PEXELS_FILTER,
    ResourceFilter,
    ResourceRelation,
} from '@app/_models/images-manager/images-management.model';
import { ApiService } from '@app/_services/api.service';
import { CommomHeaders } from '@app/_shared/httpHeaders/CommonHeaders';

@Injectable({
    providedIn: 'root',
})
export class ImagesService {
    constructor(private api: ApiService, private headers: CommomHeaders) {}

    getInstagramConfig() {
        return this.api.getFz(`/api/v1/back/instagram/url`, this.headers.getAuthHeaders());
    }

    getInstagramPhotos(next?: string) {
        const query = next ? `?next=${next}` : '';
        return this.api.getFz(`/api/v1/back/instagram/media${query}`, this.headers.getAuthHeaders());
    }

    saveInstagramToken(code: string) {
        return this.api.post(`/api/v1/back/instagram/save-token`, { code }, this.headers.getAuthHeaders());
    }

    uplodaImage(payload: FormData) {
        return this.api.postFz(`/api/v1/back/resources/upload`, payload, this.headers.getAuthHeaders());
    }

    getAllImages(filter: ImagesFilter) {
        return this.api.postFz(
            `/api/v1/back/resources/get/imagemanager/${filter.module}`,
            filter,
            this.headers.getAuthHeaders()
        );
    }

    instagramLogout() {
        return this.api.delete(`/api/v1/back/instagram/delete-token`, this.headers.getAuthHeaders());
    }

    resourcesAttach(images: ResourceRelation) {
        return this.api.postFz(`/api/v1/back/resources/attach_to`, images, this.headers.getAuthHeaders());
    }

    deleteImages(images: DeleteImages) {
        return this.api.postFz(`/api/v1/back/resources/delete`, images, this.headers.getAuthHeaders());
    }

    getOptimizationConfig() {
        return this.api.get(`/api/v1/back/config/full`);
    }

    setOptimizationConfig(status: boolean) {
        const payload = {
            optimice_images_resources: status,
        };
        return this.api.put(`/api/v1/back/config/update-any-config`, payload);
    }

    getResourcesData(filter: ResourceFilter, module?: MODULES_OPTIONS, relation_id?: number) {
        const moduleParam = module ? `/${module}` : '';
        const relationParam = relation_id ? `/${relation_id}` : '';
        return this.api.postFz(
            `/api/v1/back/resources/get/find${moduleParam}${relationParam}`,
            filter,
            this.headers.getAuthHeaders()
        );
    }

    getPexelsData(filter: PEXELS_FILTER) {
        return this.api.postFz(`/api/v1/back/pexels`, filter, this.headers.getAuthHeaders());
    }

    /**
     * ARCHIVOS
     */
    getAllFiles(filter: ImagesFilter) {
        return this.api.postFz(
            `/api/v1/back/resources/get/imagemanager/document/resources`,
            filter,
            this.headers.getAuthHeaders()
        );
    }

    getFilesSize() {
        return this.api.get(`/api/v1/back/resources/sizes`, this.headers.getAuthHeaders());
    }
}
